export default {
    indexActivityCategories:    { method: 'get',    url: 'activity_categories' },
    createActivityCategory:     { method: 'post',   url: 'activity_categories'},
    updateActivityCategory:     { method: 'put',    url: 'activity_categories/{id}'},
    deleteActivityCategory:     { method: 'delete', url: 'activity_categories/{id}'}
}